<template>
  <div>
    <validation-observer ref="checkoutPayTVForm">
      <b-card :title="'Pay-TV' + (hasCableTVOptions() ? ' (Voraussetzung ist ein aktiver TV-Kabelanschluss-Vertrag bei Cable 4)' : '')" v-if="">
        <p class="mt-1" v-if="getChannelListDocumentUrl">
          <template v-if="isPayTvService()">
            Falls Sie die einzelnen Spezifikationen und Sender des/der von Ihnen ausgewählten Pay-TV-Pakete/s noch einmal einsehen wollen, klicken Sie bitte <a :href="getChannelListDocumentUrl()" target="_blank">HIER</a>.
            <br/>
            Zusätzlich können Sie gerne auch noch eines unserer weiteren Pay-TV-Angebote buchen.
          </template>
          <template v-else>
            Falls Sie die einzelnen Spezifikationen und Sender der Pay-TV-Pakete noch einmal einsehen wollen, klicken Sie bitte <a :href="getChannelListDocumentUrl()" target="_blank">HIER</a>.
          </template>
        </p>

        <div v-for="serviceOption in SERVICE.serviceOptions" :key="serviceOption.id">
          <div
              v-if="serviceOption.description.toLowerCase().indexOf('pay-tv') > -1 || serviceOption.description.toLowerCase().indexOf('ci+-modul') > -1 || serviceOption.description.toLowerCase().indexOf('ci+ -modul') > -1"
          >
            <div v-if="serviceOption.selection == 'multi'">
              <service-options-group
                  :service-option="serviceOption"
                  :type="'checkbox'"
                  model-key="payTVOptions"
                  @input="selectCIModule()"
                  v-if="(serviceOption.description.toLowerCase().indexOf('ci+-modul') > -1 && getPayTvPackagesCount() > 0) || serviceOption.description.toLowerCase().indexOf('ci+-modul') === -1"
                  :add-minimum-term-period="serviceOption.description.toLowerCase().indexOf('ci+-modul') === -1 ? true : false"
              />

            </div>
            <div v-else>
              <service-options-group
                  :service-option="serviceOption"
                  :type="'radio'"
                  model-key="payTVOptions"
                  :reset-button="true"
                  @input="selectCIModule()"
                  :add-minimum-term-period="true"
              />
            </div>
            <template v-if="serviceOption.description.toLowerCase().indexOf('ci+-modul') > -1">
              <div v-if="showCiModuleInfoBlock" class="bg-light p-1 mt-1">
                Sie haben ein Pay-TV-Paket ausgewählt. Voraussetzung zur Nutzung eines Pay-TV-Paketes ist ein
                CI+-Modul der Cable 4. Wenn Sie bereits ein CI+-Modul von Cable 4 besitzen, deaktivieren Sie
                bitte die Option "CI+-Modul mit integrierter SmartCard" und hinterlegen Sie anschließend Ihre Cable 4-Kundennummer, damit
                die ausgewählten Pakete Ihrem CI+-Modul zugeordnet werden können.
              </div>

              <b-form-group v-if="needCustomerNumber()" label="Cable 4-Kundennummer" label-for="paytv-customernumber" class="required mt-1">
                <validation-provider
                    #default="{ errors }"
                    name="Cable 4-Kundennummer"
                    :rules="{ required: needCustomerNumber() }"
                    vid="customernumber"
                >
                  <b-form-input
                      id="paytv-customernumber"
                      v-model="CHECKOUT_DATA.customer_number"
                      placeholder="Bitte geben Sie Ihre Cable 4-Kundennummer an."
                  />
                  <small class="text-danger" :class="{'has-errors': errors.length > 0}">{{ errors[0] }}</small>
                  <small class="d-block">Die Angabe Ihrer Cable 4-Kundennummer ist Voraussetzung, neue Pay-TV-Pakete dem vorhandenen CI+-Modul zuordnen zu können.</small>
                </validation-provider>
              </b-form-group>
            </template>
          </div>
        </div>
        <div v-if="isPayTvService() && hasCableTVOptions()">
          <hr>
          Sie haben noch keinen TV-Kabelanschluss? Klicken Sie bitte
          <router-link :to="{ name: 'AvailabilitySection', params: { section: 'tvkabelanschluss' }}">
            HIER
          </router-link>
          um zuerst einen TV-Kabelanschluss zu bestellen. Anschließend haben Sie die Möglichkeit, erneut Ihre Auswahl an Pay-TV-Paketen zu treffen. Danke!
        </div>
      </b-card>
    </validation-observer>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
  BCol,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BRow,
  BFormCheckboxGroup,
  BFormRadio,
  BFormRadioGroup
} from "bootstrap-vue";
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import {required, email, digits} from '@validations'
import {required_if} from 'vee-validate/dist/rules';
import ServiceOptionItemText from "@/components/ServiceOptionItemText";
import ServiceOptionsGroup from "@/components/ServiceOptionsGroup";
import Vue from "vue";

export default {
  name: "PayTVSection",
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormCheckboxGroup,
    BFormRadioGroup,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BFormRadio,
    BFormGroup,
    BFormInput,
    ServiceOptionItemText,
    ServiceOptionsGroup,
  },
  data() {
    return {
      separateAccountOwner: false,
      active: false,
      showInfoBlock: process.env.VUE_APP_ROOT_SHOW_CABLE_4_INFO_BLOCKS,
      ciModuleAutoSelected: false,
      showCiModuleInfoBlock: false
    }
  },
  computed: {
    ...mapGetters(['SERVICE', 'CHECKOUT_DATA', 'PRODUCTS']),
  },
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(price / 100)
    },
    validateForm() {
      this.$refs.checkoutPayTVForm.validate()
    },
    hasCableTV() {
      if (this.SERVICE.hasTV) return true

      let hasTVOption = false
      this.CHECKOUT_DATA.additionalOptions.forEach(item => {
        if (item.description.toLowerCase().indexOf("kabelanschluss") > -1) {
          hasTVOption = true
        }
      })

      return hasTVOption;
    },
    selectCIModule() {
      for (let serviceOptionGroup of this.SERVICE.serviceOptions) {
        if (serviceOptionGroup.description.toLowerCase().indexOf('ci+-modul') > -1) {
          if (this.getPayTvPackagesCount() > 0) {
            if (!this.CHECKOUT_DATA.ciModuleAutoSelected) {
              let ciModulServiceOption = serviceOptionGroup.children[0]
              Vue.set(this.CHECKOUT_DATA.payTVOptions, "S_"+serviceOptionGroup.id,  []);
              this.CHECKOUT_DATA.payTVOptions["S_"+serviceOptionGroup.id].push(ciModulServiceOption)

              this.CHECKOUT_DATA.ciModuleAutoSelected = true
            }
          } else {
            Vue.set(this.CHECKOUT_DATA.payTVOptions, "S_"+serviceOptionGroup.id,  []);
            this.CHECKOUT_DATA.ciModuleAutoSelected = false
          }
        }
      }

      this.showCiModuleInfoBlock = this.getPayTvPackagesCount() > 0 && this.hasCiPlusModule()
    },
    needCustomerNumber(onlyPackages = false) {
      return (this.getPayTvPackagesCount() > 0 && !this.hasCiPlusModule())
    },
    payTvInfoBlockIsVisible() {
      this.showCiModuleInfoBlock = this.getPayTvPackagesCount() > 0 && this.hasCiPlusModule()
    },
    getPayTvPackagesCount() {
      let activePayTVPackages = 0;

      if (this.SERVICE.name.toLowerCase().indexOf('pay-tv') > -1 || this.SERVICE.name.toLowerCase().indexOf('hd-') > -1) {
        activePayTVPackages = 1;
      }

      for(let payTVOptionGroup of Object.keys(this.CHECKOUT_DATA.payTVOptions)) {
        if (Array.isArray(this.CHECKOUT_DATA.payTVOptions[payTVOptionGroup])) {
          for(let payTvOption of this.CHECKOUT_DATA.payTVOptions[payTVOptionGroup]) {
            if (payTvOption.description !== 'CI+-Modul mit integrierter SmartCard') {
              activePayTVPackages++
            }
          }
        } else {
          activePayTVPackages++
        }
      }

      return activePayTVPackages;
    },
    hasCiPlusModule() {
      let hasCIModule = false

      for(let payTVOptionGroup of Object.keys(this.CHECKOUT_DATA.payTVOptions)) {
        if (Array.isArray(this.CHECKOUT_DATA.payTVOptions[payTVOptionGroup])) {
          for(let payTvOption of this.CHECKOUT_DATA.payTVOptions[payTVOptionGroup]) {
            if (payTvOption.description === 'CI+-Modul mit integrierter SmartCard') {
              hasCIModule = true
            }
          }
        }
      }

      return hasCIModule;
    },
    isPayTvService() {
      return !this.SERVICE.hasTV && !this.SERVICE.hasPhone && !this.SERVICE.hasInternet
    },
    getChannelListDocumentUrl() {
      for (let product of this.PRODUCTS) {
        if (product.name.toLowerCase().indexOf("hd-") > -1 || product.name.toLowerCase().indexOf("paytv") > -1) {
          for (let document of product.documents) {
            if (document.type === "SL") {
              return this.getDocumentUrl(document);
            }
          }
        }
      }
    },
    getDocumentUrl(document) {
      return process.env.VUE_APP_ROOT_API + 'document/' + document.id + '/' + this.SERVICE.tenant
    },
    hasCableTVOptions() {
      for (let product of this.PRODUCTS) {
        if (product.name.toLowerCase().indexOf('tv-kabelanschluss') > -1) {
          return true;
        }
      }

      return false
    },
  },
  beforeMount() {
    if (this.SERVICE.name.toLowerCase().indexOf('pay-tv') > -1 || this.SERVICE.name.toLowerCase().indexOf('hd-') > -1) {
      this.showCiModuleInfoBlock = 1;
      this.selectCIModule()
    }

    if (this.getPayTvPackagesCount() > 0 && this.hasCiPlusModule()) {
      this.showCiModuleInfoBlock = 1;
      this.selectCIModule()
    }
  }
}
</script>

<style scoped>

</style>
